import React from 'react'

export default function Reels() {
  return (
    <div>reels</div>
  )
}
